import { ApplicationUsdaGrowerDetails, UsdaGrowerDetails } from './types'
import { UsdaGrowerDetailsTaskEditor } from './UsdaGrowerDetailsTaskEditor'

export const UsdaGrowerDetailsFeatureMap = {
  Component: {
    traitId: 'usdaGrowerDetails' as const,
    TaskEditor: UsdaGrowerDetailsTaskEditor<UsdaGrowerDetails>,
  },
  resourceType: 'user' as const,
}

export const ApplicationUsdaGrowerDetailsFeatureMap = {
  Component: {
    traitId: 'applicationUsdaGrowerDetails' as const,
    TaskEditor: UsdaGrowerDetailsTaskEditor<ApplicationUsdaGrowerDetails>,
  },
  resourceType: 'workflow' as const,
}
